import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import Portal from 'src/components/Portal';
const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;
const Overlay = styled.div`
  background: ${({
  theme
}) => theme.color.surfaceDeepFixed};
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
const ModalBody = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 268px;
  border-radius: 16px;
  margin: 0 54px;
  background: ${({
  theme
}) => theme.color.surface2};
  color: ${({
  theme
}) => theme.color.content12};
  display: flex;
  flex-direction: column;
`;
const Description = styled.div`
  align-self: center;
  padding: 24px 24px 16px 24px;
  font-size: 14px;
`;
const Button = styled.button<{
  color?: string;
}>`
  flex: 1;
  padding: 12px 16px;

  font-size: 16px;
  color: ${({
  theme,
  color
}) => color ? color : theme.color.content12};
  background-color: transparent;

  display: flex;
  justify-content: center;
  cursor: pointer;
`;
const ButtonGroup = styled.div`
  display: flex;
  border-top: ${({
  theme
}) => `1px solid ${theme.color.surface4}`};
`;
const ButtonDivider = styled.div`
  background-color: ${({
  theme
}) => theme.color.surface4};
  width: 1px;
  height: auto;
`;
interface Props {
  onCancel?: () => void;
  onConfirm?: () => void;
}
const ConfirmModal = ({
  onCancel,
  onConfirm
}: Props) => {
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  return <Portal data-sentry-element="Portal" data-sentry-component="ConfirmModal" data-sentry-source-file="ConfirmModal.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="ConfirmModal.tsx">
        <Overlay data-sentry-element="Overlay" data-sentry-source-file="ConfirmModal.tsx" />
        <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="ConfirmModal.tsx">
          <Description data-sentry-element="Description" data-sentry-source-file="ConfirmModal.tsx">{t('pg_purchase_askcancel')}</Description>
          <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="ConfirmModal.tsx">
            <Button onClick={onConfirm} color={theme.color.primary1} data-testid='payments-cancel-confirm' data-sentry-element="Button" data-sentry-source-file="ConfirmModal.tsx">
              {t('COMMON__OK')}
            </Button>
            <ButtonDivider data-sentry-element="ButtonDivider" data-sentry-source-file="ConfirmModal.tsx" />
            <Button onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="ConfirmModal.tsx">{t('COMMON__NO')}</Button>
          </ButtonGroup>
        </ModalBody>
      </Container>
    </Portal>;
};
export default ConfirmModal;